export default {"src":"/_next/static/media/variant-slash.a23f91b7.svg","height":44,"width":44,"blurWidth":0,"blurHeight":0};